import { useEffect } from 'react'
import { setDefaultFaviconEmoji, setFaviconEmoji } from 'utils/faviconUtils'

export const useFavIconEmoji = (emoji: string | null | undefined, defaultFavicon: string) => {
  useEffect(() => {
    setFaviconEmoji(emoji, defaultFavicon)

    return () => {
      setDefaultFaviconEmoji(defaultFavicon)
    }
  }, [emoji, defaultFavicon])
}
